export const keyDownSubmit = (isDisabled: boolean, submit: () => void) => {
  const SUBMIT_KEYS = ['Enter', 'Space'];
  return (e: KeyboardEvent) => { if (SUBMIT_KEYS.includes(e.code) && !isDisabled) submit() }
};
